export const FILES = {
  ALLOWED_DOC_TYPES:['.txt','.csv','.jpeg','.png','.jpg','.pdf','.rtf','.doc','.docx','.ppt','.pptx','.xlsx','.xls','.xlsm','.r','.rmd','.msg','.html'],
}
export const CONSTANTS = {
  PHASES: [
    {
      value: 'phase1',
      label: 'Phase 1',
    },
    {
      value: 'Phase 2',
      label: 'Phase 2',
    },
    {
      value: 'Phase 3',
      label: 'Phase 3',
    },
    {
      value: 'Phase 3b',
      label: 'Phase 3b',
    },
    {
      value: 'Phase 4',
      label: 'Phase 4',
    },
    {
      value: 'others',
      label: 'Others',
    },
  ],
  PROJECT_OBJECTIVES: [
    { label: 'Dose Escalation', value: 'doseEscalation' },
    { label: 'Group Sequential Design', value: 'groupSequentialDesign' },
    { label: 'Custom Design', value: 'customDesign' },
    { label: 'Master Protocol', value: 'masterProtocol' },
  ],
  LABELS: {
    CREATE_PROJECT: 'Create Project',
    PROJECT_NAME: 'Project Name',
    PROJECT_OBJECTIVE: 'Project Objective',
    SPONSORS: 'Sponsor(s)',
    PROTOCOLS: 'Protocol(s)',
    ENGAGEMENT_TYPE: 'Engagement Type',
    PROJECT_CODE: 'Project Code',
    COMPOUND: 'Compound(s)',
    INTERVENTION: 'Intervention(s)',
    THERAPEUTIC_AREAS: 'Therapeutic Area(s)',
    PROJECT_MEMBERS: 'Project Members',
    PROJECT_OWNER: 'Project Owner',
    CANCEL: 'Cancel',
    CREATE: 'Create',
    DUE_DATE: 'Due Date',
    PHASE: 'Phase',
    DETAILS: 'Details',
    MANAGE_PROJ_MEMBERS: 'Manage Project Members',
    MANAGE_DOCUMENTS: 'Manage Documents',
    PROJECT: 'Project',
    RESULTS: 'Results',
    START_TYPING: 'Start typing...',
    OTHER_THERAPEUTIC_AREA: 'Other Therapeutic Area',
    OTHER: 'Other',
    EDIT: 'Edit',
    BEGIN: 'Begin',
    PROJECT_ID: 'Project Id',
    OBJECTIVE: 'Objective',
    DATE_CREATED: 'Date Created',
    SETTINGS: 'Settings',
    OWNER: 'Owner',
    GO_BACK: 'Go Back',
    CONFIRM: 'Confirm',
    SELECT: 'Select',
    ADD: 'Add',
    INFO: 'info',
    DELETE: 'Delete',
    REMOVE: 'Remove',
    LAUNCH_SIMULATION: 'Launch Simulation',
    TRIAL_PARAMETRS: 'Trial Parameters',
    TRIAL_DURATION_PARAMETERS: 'Trial Duration Parameters',
    INCLUDE_TRIAL_DURATION_CALCULATION: 'Include Trial Duration Calculation',
    TOXICITYCURVE: 'Toxicity Curve Parameters',
    PRINTECURVES: 'Curve Parameters',
    OPERATINGCHAR: 'Operating Characteristics Parameters',
    PRIOR_SPEC: 'Prior Specifications',
    POSTERIOR_SAMPLE: 'Posterior Sampling Parameters',
    ADD_A_NEW_CURVE: 'Add New Curve',
    IMPORT_CURVE: 'Import Curve',
    NO_DATA: 'No data to display',
    NO_PROJ_MEMBERS: 'No project members to display.',
    REMOVE_PROJ_MEMBERS: 'Remove Project Member',
    ADD_NEW_MEMBER: 'Add Project Member',
    PROFILE_SETTINGS: 'Account Settings',
    NO_COMPARE_OPTIONS_SELECTED: 'You have not selected design options to compare',
    MIN_COMPARE_OPTIONS_MSG: 'You must select at least two options to compare',
    HELP: 'Help',
    WARNING: 'Warning',
    ADD_NEW_SESSION_: 'Add New Session',
    ACTION: 'Action',
    TOP_RATED: 'Top Rated Results',
    SESSION: 'Session',
    DRAFT_SESSION: 'Draft Sessions',
    SAVE_SESSION: 'Save Session',
    SESSION_AND_RESULTS: 'Sessions & Results ',
    USER: 'User',
    EMAIL: 'Email',
    ROLE: 'Role',
    ADDED_ON: 'Added On',
    NAME: 'Name',
    STATUS: 'Status',
    PROJECTS: 'Projects',
    ADD_USER: 'Add User',
    IQVIA_USER: 'IQVIA User',
    USER_ID: 'User ID',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    ERROR: 'Error',
    EXIT: 'Exit',
    YES: "Yes",
    NO: "No",
    OK: "OK",
    SAVE: 'Save',
    TENANT: "Workspace Name",
    ORGANIZATION: "Organization",
    ADMIN_NAME: "Administrator Name",
    ADMIN_EMAIL: "Administrator Email",
    ADD_TENANT: "Add Workspace",
    EDIT_TENANT: "Edit Workspace",
    ADMIN_QID: "Admin QID (if IQVIA user)",
    USER_QID: "User ID (if IQVIA user)",
    ADMIN_FIRST_NAME: "Administrator First Name",
    ADMIN_LAST_NAME: "Administrator Last Name",
    TENANT_ADDED_ON: "Added On",
    MAX_SIMULATIONS: "Max. # Simulations",
    COMMENTS: "Comments",
    IQVIA_TENANT: "IQVIA Workspace",
    ADDED_BY:"Added By",
    DOC_NAME:"Document Name",
    NO_DOCS:"There are no documents uploaded to this project.",
    UPLOAD:"Upload",
    DUPLICATE_FILE_NAME:'Duplicate File',
    INVALID_FILE_TYPE:'Invalid File Type',
    KEEP_BOTH:'Keep Both',
    REPLACE:'Replace',
    FLOWCHART: 'Flowchart',
    DECISION_TABLE: 'Decision Table',
    FLOWCHART_DECISION_TABLE: 'View Decision Table',
    COMPUTE: 'Compute',
    IQVIA_TRIAL_DESIGNER: 'IQVIA Trial Designer',
    ACCESS_RESTRICTED: 'Access restricted. Please reach out to your account administrator to request access.',
    ACCESS_LOGOUT: 'You have successfully logged out from your account.',
    ACCESS_AUTO_LOGOUT: 'You are logged out due to inactivity.',
    ADMIN_EMAIL_ID: 'Admin@Adaptivetrialdesign.com ',
    RETURN_LOGIN: 'Return to Login',
    REPORT_AN_ISSUE: 'Report an Issue',
    COPYRIGHT: 'Copyright @ 2020. All rights reserved',
    ACCESS_MULTIPLE_TENANTS: `You have access to multiple workspaces. Please select where you'd like to work.`,
    SWITCH_TENANTS: 'You can switch workspaces (and select a default workspace) from the dropdown menu in the top navigation bar at any time.',
    SAVE_AS_DEFAULT: 'Save as Default',
    VIEW_SAMPLE_SPENDING_GRAPH: 'View Sample Spending Function Graph',
    SPENDING_FUNCTIONS: 'Spending Functions',
    ADJUST_INPUTS: 'Adjust Inputs',
    ADJUST_INPUTS_MESSAGE: 'Adjust inputs and click Compute below to generate new result option',
    MIN_FOLLOW_UP: 'Specify Minimum Follow-Up Duration of Last Patient Enrolled',
    EXPECTED_TRIAL_DURATION: 'Expected Trial Duration',
    ADD_NEW_DESIGN_OPTION: '+ Add Another Design',
    TOBE_COMPUTED:'To be computed',
    SUBMIT_FEEDBACK:'Submit Feedback',
    TRAINING_VIDEO_LABEL: 'Learn More',
    SUBMIT:'Submit',
    SUBJECT:'Subject',
    MESSAGE:'Message',
    SUBMIT_FEEDBACK_UPLOAD:'Upload Image (.JPG, .JPEG, .PNG)',
    TOXICITY_PROB: 'Toxicity',
    EFFICACY_PROB:'Effectiveness or Surrogate',
    MIN_ACCEPTABLE_PROB: 'Min. Acceptable Prob.',
    TOX_AND_EFFICACY: 'Toxicity and Effectiveness or Surrogate',
    APPLICATION_NAME: 'Application Name',
    WORKSPACE: 'Workspace',
    REQ_EMAIL: 'Requester Email',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    ADD_NEW_APP: 'Add New Application',
    REGENERATE_TOKEN: 'Regenerate Token',
    SAVE_AND_REGENERATE: 'Save & Regenerate',
    APP_NAME: 'Application Name',
    APP_DESCRIPTION: 'Description',
    TOKEN_VALIDITY: 'Token Validity',
    EFFECTIVENESS:'Effectiveness',
    SHARE_SESSION: 'Share Session',
    NO_DATA_ADDED_CURVES: 'No curves added to display. Enter the dose amounts and confirm to add a new curve',
    NO_DATA_FROM_PREVIOUS_SESSIONS: 'Previous sessions in current project must be published to display available curves on subsequent new sessions',
    SHARE_SESSION_APPLY: 'Apply',
    SHARE_SESSION_CANCEL: 'Cancel',
    SALESFORCE_OPPORTUNITY_NUMBER:'Salesforce Opportunity Number'
  },
  ACCESSOR: {
    PROJECT_NAME: 'projectname',
    PROJECT_ID: 'projectid',
    SPONSORS: 'sponsor',
    ENGAGEMENT_TYPE: 'engagementType',
    OWNER: 'owner',
    OBJECTIVE: 'objective',
    DATE_CREATED: 'createdat',
    THERAPEUTIC_AREAS: 'therapeticarea',
    PROJECT_MEMBERS: "pmcount",
    SETTINGS: 'action',
    NAME: 'name',
    EMAIL:'email',
    ADDED_ON: 'addedon',
    ROLE: 'role',
    STATUS: 'status',
    PROJECTS: 'projects',
    TENANT: "tenant",
    TENANT_ADDED_ON: 'addedOn',
    ORGANIZATION: "organization",
    ADMIN_NAME: "adminName",
    ADMIN_EMAIL: "adminEmail",
    APPLICATION_NAME: 'applicationName',
    WORKSPACE: 'workspace',
    REQ_EMAIL: 'reqEmail',
    START_DATE: 'startDate',
    END_DATE: 'endDate'
  },
  VALIDATION_MESSAGES: {
    REQUIRED: 'Required',
    TOO_LONG: 'Allowed Character Limit is 200',
    VALID_EMAIL: 'Please enter a valid email',
    FEEDBACK_SUBJECT_TOO_LONG: 'Allowed Character Limit is 80',
    FEEDBACK_MESSAGE_TOO_LONG: 'Allowed Character Limit is 800',
    SUBMIT_FEEDBACK_ALLOWED_FILE_TYPES: 'Allowed file types: .jpg , .jpeg, .png',
    SUBMIT_FEEDBACK_ALLOWED_FILE_SIZE: 'Maximum allowed file size is 10 MB',
    SUBMIT_FEEDBACK_ALLOWED_FILE_NAME_LENGTH: 'Maximum allowed file name length is 65 characters',
    TOX_EFFICACY_MESSAGE:'Probability value must be greater than 0 and less than 1 and increase monotonically for toxicity.',
    TOX_MESSAGE: 'True toxicity probability value must be greater than 0 and less than 1',
    APP_NAME_TOO_LONG: 'Allowed Character Limit is 16',
    APP_DESC_TOO_LONG: 'Allowed Character Limit is 32',
    OPPORTUNITY_NUMBER_TOO_LONG:'Allowed Character Limit is 120'
  },
  INFORMATIONAL_MESSAGES: {
    PROJECT_CANCEL:
      'Are you sure you want to cancel the creation of this new project? This cannot be undone.',
    SUBMIT_FEEDBACK_CANCEL:
      'Are you sure you want to cancel the submission of this feedback? This cannot be undone.',
    PROJECT_EDIT_CANCEL:
      'Are you sure you want to cancel the update of this project?',
    SIMULATION_REVIEW:
      'Please review and fill in the parameters below to launch simulation.',
    SIMULATION_PARAMETER_TOOLTIP:
      'You must add atleast one design option and a curve and fill in the form parameters below to launch simulation',
    ADD_USER_CANCEL:
      'Are you sure you want to cancel adding a new user?',
    ADD_TENANT_CANCEL:
      'Are you sure you want to cancel adding a new workspace?',
    CONFIRM_CHANGE_OWNER: (ownerName: string, projectName: string) =>
      `Are you sure you want to update ${ownerName} as the owner of ${projectName}?`,
    CONFIRM_RETAIN_OWNER: (ownerName: string, projectName: string) =>
      `Do you want to retain ${ownerName} as a project member within the ${projectName}?`,
    SUCCESS_CHANGE_OWNER: (ownerName: string, projectName: string) =>
      `Success! Owner of ${projectName} has been updated to ${ownerName}.`,
    UPDATE_PROJECT_REVIEW: 'An error occurred while updating the project! Please try again.',
    DELETE_PROJECT_REVIEW: 'An error occurred while deleting the project! Please try again.',
    DELETE_PROJECT_SUCCESS: (projectName: string) =>
      `Project - ${projectName} deleted successfully`,
    EDIT_TENANT_CANCEL:
      'Are you sure you want to cancel editing the workspace?',
    GROUP_SEQUENTIAL:  'Group Sequential',
    GROUP_SEQUENTIAL_SUBTITILE: 'Please review and fill in the parameters below to compute sample size or power for two-arm time-to-event trials',
    GROUP_SEQUENTIAL_COMPUTE_MSG: 'You can return to this session through Edit or Clone actions from results page to modify the inputs and compute again',
    NOT_SAVED: 'Would you like to save any changes you made before leaving this page?',
    CONFIRM_LEAVE: 'Are you sure you want to leave?',
    FINAL_CONFIRM_LEAVE: 'Changes you made will not be saved. Are you sure you want to leave this page?',
    COMPUTING_RESULTS_MESSAGE: (sessionType: string) => {
      return (sessionType === 'Group Sequential' 
      ? `Computation is in progress for your session. You may refresh to check if results are ready.`
      : `Simulations are in progress for your session. You may refresh to check if results are ready.`)
    },
    CONFIRM_TERMINATE_SIMULATION: (sessionName: string) =>
      `Simulation run for ${sessionName} will be terminated and the session will be retained with given input parameters. Are you sure you want to cancel the simulation ?`,
    SIMULATION_TERMINATION_SUCCESS: (sessionName: string, projectName: string) =>
      `Simulation run for ${sessionName} is terminated successfully. You can go back to the session from Draft Sessions section on ${projectName} project in order to launch the simulation again.`,
    SIMULATION_SUCCESS: (projectSessionId: string, projectName: string) =>
      `Simulation results for your Session ${projectSessionId} in ${projectName} project are ready. Navigate to ${projectName} project to access the results`,
    CONFIRM_DELETE_SESSION:(sessionId:string,sessionName:string) => 
      `Are you sure you want to delete your Session ${sessionId} - ${sessionName} ? This action cannot be undone.`,
    CONFIRM_DELETE_OPTION:(sessionId:string,sessionName:string, optionId:string) => 
      `Are you sure you want to delete your Session ${sessionId} - ${sessionName} - ${optionId}? This action will permanently delete the selected option and all associated data.`,
    DELETE_SESSION_SUCCESS:(sessionId:string,sessionName:string) =>
      `Session ${sessionId} - ${sessionName} deleted successfully.`,
    DELETE_OPTION_SUCCESS:(sessionId:string,sessionName:string, optionId:string) =>
      `Session ${sessionId} - ${sessionName} - ${optionId} deleted successfully.`,
    DOSE_COMPARE_MESSAGE:'You can compare maximum upto 6 unique design options and 6 unique toxicity curves from the selected result options',
    DOSE_COMPARE_DIFFERENT_ENDPOINTS:'This is unavailable for results comparison of different endpoint options. Select results options of same endpoint to view comparison of results grouped under common curves and designs',
    SESSION_RESULT_DELETE_MESSAGE: (sessionId:string,sessionName:string) => `Unable to retrieve Session ${sessionId} - ${sessionName} information.`,
    SESSION_COMPARE_RESULTS_DELETE_MESSAGE: 'Unable to complete the action as some selected results are unavailable.Page is refreshed to display latest information.',
    MAX_DESIGN_OPTION_CROSSED_MESSAGE: 'Maximum 6 design options per session',
    MAX_TOXICITY_CURVE_CROSSED_MESSAGE: 'Maximum 6 curves per session',
    CONFIRM_DOSE_AMOUNTS: 'Confirm the dose amounts to add new curve',
    ADD_DESIGN_OPTION_MESSAGE: 'Click to add new design',
    ADD_TOXICITY_CURVE_MESSAGE: 'Click to add new curve',
    CONFIRM_LOCK_TO_LAUNCH: 'Toxicity curves will reflect any changes made to dose level and amounts. Confirm dose amounts to launch simulation.',
    DOSE_LEVEL_CHANGE:'All newly added curves with previous dose level will be removed and the list of previous session curves will update to include the ones that match updated dose level and dose amount. Do you want to proceed with the update?',
    DOSE_AMOUNT_CHANGE:'Any newly added equation-based curves will be recalculated using the updated dose amount and the previous session curves list will update to include the ones that match updated dose amount. Do you want to proceed with the update?',
    PREVIOUS_SESSION_MESSAGE:'Add a maximum of six curves to this session including curves from previous sessions.',
    PUBLISH_SESSION_SUCCESS:(sessionId:string,sessionName:string) =>
      `Session ${sessionId} - ${sessionName} published successfully.`,
      DECISION_TABLE_ERROR:(message:string) => `The decision table couldn't be generated because ${message}`,
    SUBMIT_FEEDBACK_SUCCESS_MESSAGE: 'You have successfully submitted feedback. Thank you!',
    SUBMIT_FEEDBACK_ERROR_MESSAGE: 'Something went wrong while submitting feedback. Try after sometime!',
    ACCRUAL_SUM_ERROR_MESSAGE: 'Sum of all accrual period durations specified should be less than the difference between Expected Trial Duration and Minimum Follow-up Duration',
    DLT_WINDOW_WARNING: 'Please note that your chosen DLT window is fairly long and thus trial may take excessive time.',
    COHERT_RECRUITMENT_WARNING: 'Please note that your chosen cohort recruitment time is fairly long and thus trial may take excessive time.',
    NO_TRUE_RP2D: 'No true RP2D identified for given design input.',
    PROJECT_DELETE_CONFIRM: ( projectName: string) => `Are you sure you want to delete the ${projectName}? This action will permanently delete the selected project and all associated sessions.`,
    REPORTED_RP2D_DESCRIPTION:(effectiveness:string) => [
      {
        title: 'RP2D: ',
        subtitle: 'Recommended Phase 2 Dose from software. May be different from recommendation of trial safety committee/DMC.',
      },
      {
        title: 'True RP2D: ',
        subtitle: `This is any dose whose P(DLT)<= pT+E2 and whose P(success on the ${effectiveness})>= Target Probability of ${effectiveness}`,
      },
      {
        title: 'Provisional RP2D:',
        subtitle: 'This is the one chosen most often by the algorithm',
      },
    ],
    ADD_APP_CANCEL:'Are you sure you want to cancel adding a new application?',
    ADD_APP_VALIDITY:'Application integration will be valid through specified dates. Leave end date blank if you would like integration to be valid indefinitely',
    TRIAL_DURATION_SECTION_MESSAGE: 'Expected Days for Treatment',
    CANCEL_SIMULATION_CANCEL_ERROR: 'Simulation run is completed and cannot be cancelled. Return to session parameters to edit the inputs and re-run the simulation',
    NO_SESSION_MEMBERS: 'Please contact admin to add members',
    PRINTE_MESSAGE:'PRINTE does not have a stopping rule as the effect of a stopping rule on the fidelity of results is unexplored & hence stops at the Max. Sample Size.',
    BIONET_MESSAGE: "BOIN ET is a BOIN Efficacy and Toxicity two-parameter dose-escalation design with a simple utility function u=eff*(1-tox)",
    CLONE_CONFIRM: 'Your session will be cloned in a new session. Do you want to continue?',
    ACCURAL_CALCULATE_WARNING_MESSAGE:`The specified "Monitoring duration of the last recruited subject'' is too short to observe the required number of events. Please increase this input parameter and recalculate accrual.`,
    ACCURAL_CALCULATE_ERROR_MESSAGE:`Sorry!! Something went wrong while saving`
  },
  DOSE_ESCALATION: {
    DESIGN: {
      THREEPLUSTHREE: '3+3',
      I3PLUS3: 'i3+3',
      CRM: 'CRM',
      BOIN: 'BOIN',
      mTPI2: 'mTPI-2',
      REDOS: 'REDOS',
      BLRM: 'BLRM',
    },
    DEFAULT_DOSE_LEVEL: 5,
  },
  TRIAL_PARAMETRS_NAME: {
    SIMULATION: 'simulation',
    RAMDOM_SEED: 'randomSeed',
    TARGET_PROB_TOXICITY: 'targetProbabilityToxicity',
    MAX_DOSE_LEVELS: 'maxDoseLevels',
    STARTING_DOSE_LEVELS: 'startingDoseLevel',
    DOSE_UNIT: 'doseUnit',
    TARGET_2ND_PARAM_PROB: 'target2ndParamProb',
  },
  TRIAL_PARAMETRS_LABEL: {
    SIMULATION: '# Simulations',
    RAMDOM_SEED: 'Random Seed',
    TARGET_PROB_TOXICITY: 'Target Toxicity Prob.',
    MAX_DOSE_LEVELS: 'Max # Dose Levels',
    STARTING_DOSE_LEVELS: 'Starting Dose Level',
    DOSE_UNIT: 'Dose Unit',
    TARGET_2ND_PARAM_PROB:(target2ndProbName:string) => `Target ${target2ndProbName} Prob.`,
  },
  TRIAL_DURATION_GRAPH: {
    TOTAL_COHORT_DIST: 'Total # Cohorts Distribution',
    TRIAL_DURATION_DIST: 'Trial Duration Distribution',
    SAMPLE_SIZE_DIST: 'Sample Size Distribution',
  },
  TRIAL_PARAM_VALIDATION_MESSAGES: {
    REQUIRED: 'Required',
    MAX_DOSE: 'Max Dose Levels must be less than or equal to 20',
    POSITIVE: 'Enter only positive numbers',
    NOT_VALID_NUMBER: 'Not a valid number',
  },
  ROLES: {
    DESIGNER: 'Designer',
    REVIEWER: 'Reviewer',
  },
  FLOWCHART_CONTENT: {
    TREAT_PATIENTS: (cohort: string) =>
    `Treat ${cohort} subjects`,
    REACHED_MAX_SIZE: (max: string) =>
    `Reached ${max} subjects?`,
    DEESCALATE_DOSE: 'De-escalate the dose',
    CALCULATE_AT_CURRENT: 'DLT Rate at current dose within boundary?',
    ESCALATE_DOSE: 'Escalate the dose',
    RETAIN_ON_CURRENT: 'Retain on the current dose',
    TREATED_SUBJECTS: (earlyCutoff: string) =>
    `Treated ${earlyCutoff} subjects at this dose ?`,
    STOP_SELECT: 'Stop and Select MTD',

  },
  LINEAR_CURVE_FORMULA: (
    E: number | string = 0.1,
    b: number | string,
    x: number | string,
    maxDoseLevels: number | string
  ) => {
    if (+b === 100) {
      b = 0.8 / +maxDoseLevels;
    }
    return +E + +b * +x;
  },
  LOGISTIC_CURVE_FORMULA: (E0: number | string = 0.1, EMax: number = 0.8, ED50: number, h: number = 1, x: number) => {
    return (+E0 + +EMax / (1 + Math.exp(-h * (Math.log(x) - Math.log(ED50)))))
  },
  HILL_CURVE_FORMULA: (E0: number | string = 0.1, EMax: number = 0.8, ED50: number, h: number = 1, x: number) => {
    return (+E0 + (+EMax * Math.pow(x, +h)) / (Math.pow(ED50, +h) + Math.pow(x, +h)))
  },
  QUADRATIC_CURVE_FORMULA: (E0: number | string = 0.1, b1: number, b2: number, x: number) => {
    return (+E0 + (+b1 * x) + (+b2 * (Math.pow(x, 2))))
  },
  EXP_CURVE_FORMULA: (E0: number | string = 0.1, EMax: number = 0.8, h: number = 1, x: number) => {
    return (+E0 + (+EMax * (1 - Math.exp(-h * x))))
  },
  QUADRATIC_CONCAVE_CURVE_FORMULA:(k:number,a:number,x:number|string,h:number|string) => {
    return (a* Math.pow((+x - +h),2)+k)
  },
  INVALID_FILE_TYPE:`Invalid file type. Please upload a file with one of the following extensions: ${FILES.ALLOWED_DOC_TYPES.join(', ')}`,
  FILE_SIZE_EXCEEDS_15MB:'File size has exceeded max limit of 15MB',
  TENANCY_LIMIT_EXCEEDED:(name:string) => {
    return `Maximum file size upload limit is occupied within ${name}.`;
  },
  REMOVE_DOCUMENT:(name:string,docName:string) => {
    return `Are you sure you want to remove the document ${docName} from ${name} ?`;
  },
  DUPLICATE_FILE_NAME:'A document with this name already exists in this project. What would you like to do?',
  ERROR_CODES_DOC_UPLOAD: {
    EXCEEDS_15MB:'File Size < 15 MB',
    EXCEEDS_TENANCY_LIMIT:'Maximum file size for Workspace',
    DUPLICATE_FILE:'Duplicate File'
  },
  DECISION_TABLE_LABELS:{
    ESCALATE_DOSE:'Escalate Dose',
    CURRENT_DOSE:'Stay at Current Dose',
    DEESCALATE_DOSE:'De-Escalate to Prior Dose',
    NO_RETURN:'De-Escalate/Do Not Return to Current Dose',
    DE_ESCALATE:'De-escalate/Stay/Escalate',
    X_AXIS:'Number of Patients',
    Y_AXIS:'Number of Patients with Observed DLT'
  },
  DECISION_TABLE_TYPES:{
    ESCALATE_DOSE:'escalateDose',
    CURRENT_DOSE:'currentDose',
    DEESCALATE_DOSE:'deescalteDose',
    NO_RETURN:'noReturn',
    DE_ESCALATE:'De-escalate/Stay/Escalate'
  },
  DECISION_TABLE_VISIBILITY_CONFIG:['BOIN','mTPI-2', 'i3+3', 'BOIN ET'],
  UNIQUE_DESIGN_AND_CURVES_LENGTH:6,
  API_MESSAGES:{
    SUCCESS:'Successful',
    FAILURE:'Failure'
  }
};
export const SESSIONSTORAGE = {
  COMPARE_RESULTS: (name: string) => {
   return `${name}CompareResult`
  }
}

export const SampleSubjectBase64URLS = {
  dlt:"data:image/png;base64,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",
  noDLT:"data:image/png;base64,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"
}

export const GS_TOOLTIPS = {
  TRIAL_DURATION : {
    NO:'If Minimum Follow-Up is given but Trial Duration is not specified, then the algorithm will find the design by varying accrual duration while using accrual rate input given by the user.',
    YES:'If Minimum Follow-Up and Trial Duration are given, then algorithm tries to find the design by varying accrual rate.'
  },
  MINFUP:{
    NO:'Select "No" if alogrithm should find the design by varying Follow-Up Duration for Last Patient Enrolled while using accrual rates and corresponding periods supplied by the user.'
  },
  USE_PIECWISE_ACCRUAL_RATE:{
    NO:'Select "No" if alogrithm should find the design by varying Follow-Up Duration for Last Patient Enrolled while using accrual rates and corresponding periods supplied by the user.'
  }
}

export const TOOLTIPS = {
  POSTIERIOR_DISTRUBUTION: "To make this graph system first form a set, A, which contains only the simulation runs where the modal dose was chosen. For each of the runs in the set A, a posterior distribution can be formed. From each posterior distribution, system takes 1,000 draws and counts how many of the draws fall inside the graduation region in each case. Then the elements of the set A are sorted from ‘least inside’ to ‘most inside’ the graduation region. From this sorted set  three percentiles are taken: the 25^th^, the 50^th^ (the median), and the 75^th^. For each of these posteriors, system plots the 950 most likely of the 1,000 draws"
}

export const TOXICITYCURVE_ALLOWED_KEY_CODES = {
  TAB_KEY : 9,
  BACKSPACE : 8,
  START:0,
  END:5,
  ARROW_LEFT:37,
  ARROW_RIGHT:39,
  DELETE:46,
  MAX_LENGTH:3,
  CTRL:65,
  A:97
}

export const DEFAULT_VIEW_HEADERS = {
  rp2D:'Distribution of selected RP2D by Dose',
  mtd:'Distribution of selected MTD by Dose'
}

export const EDIT_RANGE_FORM_LABELS = {
  CANCEL:'CANCEL',
  UPDATE:'UPDATE',
  TITLE:'Edit Range',
  MIN:'Min Range',
  MAX:'Max Range',
  INTERVAL:'Interval'
}

export const FIXED_DESIGN_GRAPHS = {
  DIFFBINOM_SAMPLE_SIZE_HEADERS:["Type 2 Error (β)",
  "Power",
  "Total # Subjects[n]",
  "Subjects in Control Group (nc)",
  "Subjects in Treatment Group[nt]"],
  DIFFBINOM_INVESTIGATIONAL_ARMS_INFO:"Default range of Investigational arm has been predifined to range \n from ( Proportion of Control Group(Pc) to( 0.5*Proportion in Control Group (Pc)"
}

export const S3_DOCS = {
  HELP_MANUAL: 'Adaptive_Trial_Design_User_Manual.pdf',
  RELEASE_NOTES: 'Release_Notes_Adaptive_Trial_Design.pdf'
};
